import { roleTypeOptions } from "./config/AppConstants";
import * as log from "./Feedback/Log";
//General
export const formatId = id => {
  let reformattedId = "Not Set";

  if (id) {
    reformattedId = id.substring(3).replace(/^0+/, "");
  }

  return reformattedId;
};

export const formatDate = (date, format) => {
  let reformattedDate = "Not Set";

  if (date) {
    reformattedDate = JSON.stringify(date)
      .replace(/"/g, "")
      .replace("T", " ")
      .replace("Z", "");

    switch (format) {
      case "YYYYMMDDHHMMSS":
        reformattedDate = reformattedDate.slice(0, -4);
        break;

      case "YYYYMMDDHHMM":
        reformattedDate = reformattedDate.slice(0, -7);
        break;

      case "YYYYMMDDHH":
        reformattedDate = reformattedDate.slice(0, -10);
        break;

      case "YYYYMMDD":
        reformattedDate = reformattedDate.slice(0, -13);
        break;

      case "YYMMDD":
        reformattedDate = reformattedDate.slice(2, -13);
        break;

      default:
    }
  }

  return reformattedDate;
};

export const getEmbeddedDatePropertyFormatted = (
  object,
  propertyName,
  format
) => {
  var date = getEmbeddedProperty(object, propertyName);
  if (date) {
    return formatDate(date, format);
  } else {
    return "";
  }
};
export const formatRoleType = roleNumber => {
  let roleType = "";

  roleTypeOptions.forEach(e => {
    if (roleNumber === e.value) {
      roleType = e.label;
    }
  });

  return roleType;
};
export const cloneArray = array => {
  if (Array.isArray(array)) {
    return deepCopy(array);
  } else {
    return {};
  }
};
export const deepCopy = object => {
  try {
    return JSON.parse(JSON.stringify(object));
  } catch (error) {
    log.error(error.message);
    return null;
  }
};

export const parsePojoRow = (id, quantity) => {
  var pojo = {};
  pojo.id = id;
  pojo.quantity = quantity;
  return pojo;
};
export const parsePojoList = pojoList => {
  var pojoJSON = JSON.stringify(pojoList);
  return pojoJSON;
};

export const capitalize = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
export const isNotNull = object => {
  if (object === null) {
    return false;
  }
  if (object === undefined) {
    return false;
  }
  if (Array.isArray(object) && object.length === 0) {
    return false;
  }
  if (object === "") {
    return false;
  }

  return true;
};

export const getEmbeddedProperty = (object, propertyName) => {
  console.log(object);
  console.log(propertyName);
  if (!isNotNull(object)) {
    return "";
  } else {
    if (isNotNull(object[propertyName])) {
      return object[propertyName];
    } else {
      return "";
    }
  }
};

export const getBooleanValue = (object, propertyName) => {
  var boolean = getEmbeddedProperty(object, propertyName);
  if (boolean) {
    console.log("Returning YES for Boolean");
    return "Yes";
  } else {
    console.log("Returning NO for Boolean");
    return "No";
  }
};

export const validateValues = fieldList => {
  let disable = false;
  if (isNotNull(fieldList)) {
    if (Array.isArray(fieldList)) {
      fieldList.forEach(element => {
        if (!element) {
          disable = true;
        }
      });
    } else {
      if (!fieldList) {
        disable = true;
      }
    }
  }
  return disable;
};

export const isJsonEqual = (original, current) => {
  if (original === JSON.stringify(current)) {
    return true;
  } else {
    return false;
  }
};

export const isFunction = functionToCheck => {
  var getType = {};
  let isFunctionResult =
    functionToCheck &&
    getType.toString.call(functionToCheck) === "[object Function]";
  return isFunctionResult;
};

export const readInAddressDetails = object => {
  if (isNotNull(object)) {
    let addressLine1 = getEmbeddedProperty(object, "addressLine1");
    let addressLine2 = getEmbeddedProperty(object, "addressLine2");
    let addressLine3 = getEmbeddedProperty(object, "addressLine3");
    let addressLine4 = getEmbeddedProperty(object, "addressLine4");
    let city = getEmbeddedProperty(object, "city");
    let postcode = getEmbeddedProperty(object, "postalZipCode");

    return (
      addressLine1 +
      "\n" +
      addressLine2 +
      "\n" +
      addressLine3 +
      "\n" +
      addressLine4 +
      "\n" +
      city +
      "\n" +
      postcode
    );
  } else {
    return "";
  }
};
export const readInCustomerAddressDetails = (customerId, list) => {
  if (isNotNull(customerId)) {
    if (isNotNull(list)) {
      var object = {};
      list.forEach(element => {
        if (element.id === customerId) {
          object = deepCopy(element);
        }
      });
      let addressLine1 = getEmbeddedProperty(object, "addressLine1");
      let addressLine2 = getEmbeddedProperty(object, "addressLine2");
      let city = getEmbeddedProperty(object, "city");
      let postcode = getEmbeddedProperty(object, "postalZipCode");

      return addressLine1 + "\n" + addressLine2 + "\n" + city + "\n" + postcode;
    } else {
      return "";
    }
  } else {
    return "";
  }
};



// WEBPACK FOOTER //
// ./src/common/FormatFunctions.js